export function getCSRFToken() {
  const csrfMetaElement: HTMLMetaElement = document.head.querySelector('[name=csrf-token]');
  return csrfMetaElement.content;
}
